// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Edit, Update, Approve, Delete
// MODIFIED DATE : 20-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import BusinessLoanProposalActionTypes from './business-loan-proposal.types';
import {
	createNewBusinessLoan,
	updateBusinessLoan,
	businessLoanProposalListFetch,
	businessLoanProposalApprove,
	businessLoanProposalDetailsFetch,
	businessLoanProposalDelete,
} from './business-loan-proposal.service';

import {
	addBusinessLoanPropsalSuccess,
	addBusinessLoanPropsalFailure,
	addBusinessLoanPropsalResponseChanged,
	updateBusinessLoanProposalSuccess,
	updateBusinessLoanProposalFailure,
	updateBusinessLoanProposalResponseChanged,
	getBusinessLoanPropsalListSuccess,
	getBusinessLoanPropsalListFailure,
	getBusinessLoanPropsalListResponseChanged,
	approveBusinessProposalSuccess,
	approveBusinessProposalFailure,
	approveBusinessProposalResponseChanged,
	fetchBusinessLoanProposalSuccess,
	fetchBusinessLoanProposalFailure,
	fetchBusinessLoanProposalResponseChanged,
	deleteBusinessLoanProposalSuccess,
	deleteBusinessLoanProposalFailure,
	deleteBusinessLoanProposalResponseChanged,
} from './business-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS LOAN PROPOSAL   ******************** */
export function* craeteNewLoanProposal({ payload }: any) {
	try {
		const key = 'AddBusinessLoanProposalKey';
		const {
			branchID,
			centerID,
			officerID,
			businessID,
			loanProposalDate,
			loanStartDate,
			loanEndDate,
			memberMeetUpLocation,
			meetUpLat,
			meetUpLog,
			meetUpTime,
			productID,
			loanIndexType,
			principalAmount,
			interestAmount,
			interestPercentage,
			productROI,
			instalmentType,
			numberOfInstalment,
			amountOutsanding,
			installmentMethod,
			installmentReturnType,
			noOfInstallment,
			insuranceFee,
			processingFee,
			CGSTFee,
			SGSTFee,
			IGSTFee,
			documentCharge,
			memberAmount,
			hpFee,
			verificationFee,
			noOfStartDay,
			loanType,
			purposeOfLoanID,
			productAmountReceived,
			productOutstanding,
			userID,
			companyID,
			databaseName,
			isFixedEMI,
			fixedEMIAmount,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			CenterID: centerID,
			GroupOfficerID: officerID,
			BusinessID: businessID,
			LoanProposalDate: loanProposalDate,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			MeetUpLocation: memberMeetUpLocation,
			MemberMeetupLat: meetUpLat,
			MemberMeetupLong: meetUpLog,
			MeetUpTime: meetUpTime,
			ProductID: productID,
			LoanIndexType: loanIndexType,
			ProductAmount: principalAmount,
			ProductPrincipal: interestAmount,
			ProductInterest: interestPercentage,
			ProductROI: productROI,
			InstalmentType: instalmentType,
			NumberOfInstalment: numberOfInstalment,
			AmountOutsanding: amountOutsanding,
			InstallmentMethod: installmentMethod,
			InstallmentReturnType: installmentReturnType,
			NoOfInstallment: noOfInstallment,
			DocumentCharges: documentCharge,
			ProcessingFee: processingFee,
			CGSTFee: CGSTFee,
			SGSTFee: SGSTFee,
			VerificationFee: verificationFee,
			HPFee: hpFee,
			InsuranceFee: insuranceFee,
			IGSTFee: IGSTFee,
			MemberAmount: memberAmount,
			Noofstartday: noOfStartDay,
			LoanType: loanType,
			PurposeOfLoanID: purposeOfLoanID,
			AmountReceived: productAmountReceived,
			AmountOutStanding: productOutstanding,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			IsFixedEMI: isFixedEMI,
			FixedEMIAmount: fixedEMIAmount,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createNewBusinessLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessLoanPropsalFailure(responseData.data));
		} else {
			yield put(addBusinessLoanPropsalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessLoanPropsalFailure(error));
	}
}

export function* resetAddBusinessLoanProposalResponse() {
	yield put(addBusinessLoanPropsalResponseChanged());
}

export function* onCreateBusinessLoanProposal() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.ADD_BUSINESS_LOAN_PROPOSAL_START,
		craeteNewLoanProposal,
	);
}

export function* onCreateBusinessLoanProposalResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.ADD_BUSINESS_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddBusinessLoanProposalResponse,
	);
}
/** *********************  END ADD BUSINESS LOAN PROPOSAL  ******************** */

/** *********************  START UPDATE BUSINESS LOAN PROPOSAL   ******************** */
export function* businessLoanProposal({ payload }: any) {
	try {
		const key = 'UpdateBusinessLoanProposalKey';
		const {
			businessLoanProposalID,
			branchID,
			centerID,
			officerID,
			businessID,
			loanProposalDate,
			loanStartDate,
			loanEndDate,
			memberMeetUpLocation,
			meetUpLat,
			meetUpLog,
			meetUpTime,
			productID,
			loanIndexType,
			principalAmount,
			interestAmount,
			interestPercentage,
			productROI,
			instalmentType,
			noOfInstallment,
			amountOutsanding,
			installmentMethod,
			installmentReturnType,
			noOfYears,
			insuranceFee,
			processingFee,
			CGSTFee,
			SGSTFee,
			IGSTFee,
			documentCharge,
			memberAmount,
			hpFee,
			verificationFee,
			noOfStartDay,
			loanType,
			purposeOfLoanID,
			purposeOfLoanCategoryID,
			productAmountReceived,
			productOutstanding,
			loanDisbursementDate,
			userID,
			companyID,
			databaseName,
			isFixedEMI,
			fixedEMIAmount,
		} = payload;
		const jsonData = {
			LoanIndexID: businessLoanProposalID,
			BranchID: branchID,
			CenterID: centerID,
			GroupOfficerID: officerID,
			BusinessID: businessID,
			LoanProposalDate: loanProposalDate,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			MeetUpLocation: memberMeetUpLocation,
			MemberMeetupLat: meetUpLat,
			MemberMeetupLong: meetUpLog,
			MeetUpTime: meetUpTime,
			ProductID: productID,
			LoanIndexType: loanIndexType,
			ProductAmount: principalAmount,
			ProductPrincipal: interestAmount,
			ProductInterest: interestPercentage,
			ProductROI: productROI,
			InstalmentType: instalmentType,
			NumberOfInstalment: noOfInstallment,
			AmountOutsanding: amountOutsanding,
			InstallmentMethod: installmentMethod,
			InstallmentReturnType: installmentReturnType,
			NoOfYears: noOfYears,
			DocumentCharges: documentCharge,
			ProcessingFee: processingFee,
			CGSTFee: CGSTFee,
			SGSTFee: SGSTFee,
			VerificationFee: verificationFee,
			HPFee: hpFee,
			InsuranceFee: insuranceFee,
			IGSTFee: IGSTFee,
			MemberAmount: memberAmount,
			Noofstartday: noOfStartDay,
			LoanType: loanType,
			PurposeOfLoanID: purposeOfLoanID,
			purposeOfLoanTypeID: purposeOfLoanCategoryID,
			AmountReceived: productAmountReceived,
			AmountOutStanding: productOutstanding,
			LoanDisbursementDate: loanDisbursementDate,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			IsFixedEMI: isFixedEMI,
			FixedEMIAmount: fixedEMIAmount,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateBusinessLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessLoanProposalFailure(responseData.data));
		} else {
			yield put(updateBusinessLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessLoanProposalFailure(error));
	}
}

export function* resetUpdateBusinessLoanProposalResponse() {
	yield put(updateBusinessLoanProposalResponseChanged());
}

export function* onUpdateBusinessLoanProposal() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.UPDATE_BUSINESS_LOAN_PROPOSAL_START,
		businessLoanProposal,
	);
}

export function* onUpdateBusinessLoanProposalResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.UPDATE_BUSINESS_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateBusinessLoanProposalResponse,
	);
}
/** *********************  END UPDATE BUSINESS LOAN PROPOSAL  ******************** */

/** *********************  START GET BUSINESS LOAN PROPOSAL  ******************** */
export function* businessLoanProposalListGet({ payload }: any) {
	try {
		const key = 'GetBusinessLoanProposalListKey';
		const {
			companyID,
			branchID,
			userID,
			userRole,
			userLevel,
			loanIndexType,
			databaseName,
			inputSearch,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			LoanIndexType: loanIndexType,
			DatabaseName: databaseName,
			SearchData: inputSearch,
			Limit: limit,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanProposalListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessLoanPropsalListFailure(responseData.data));
		} else {
			yield put(getBusinessLoanPropsalListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessLoanPropsalListFailure(error));
	}
}

export function* resetGetBusinessLoanProposalListResponse() {
	yield put(getBusinessLoanPropsalListResponseChanged());
}

export function* onGetBusinessLoanProposal() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.GET_BUSINESS_LOAN_PROPOSAL_LIST_START,
		businessLoanProposalListGet,
	);
}

export function* onGetBusinessLoanProposalListResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.GET_BUSINESS_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
		resetGetBusinessLoanProposalListResponse,
	);
}
/** *********************  END GET BUSINESS LOAN PROPOSAL ******************** */

/** *********************  START APPROVE BUSINESS LOAN PROPOSAL  ******************** */
export function* approveBusinessProposalData({ payload }: any) {
	try {
		const key = 'BusinessLoanProposalApprovalKey';
		const {
			loanIndexID,
			appraisalLevel,
			userID,
			userName,
			appraisalApproveSetupID,
			appraisalApproveID,
			isAppraisalApproveNeeded,
			isAllApproved,
			noOfAppraisalApproval,
			appraisalNotes,
			type,
			companyID,
			databaseName,
		} = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			AppraisalLevel: appraisalLevel,
			AppraisalDoneBy: userID,
			AppraisalDoneByUserName: userName,
			AppraisalApproveSetupID: appraisalApproveSetupID,
			AppraisalApproveID: appraisalApproveID,
			IsAppraisalApproveNeeded: isAppraisalApproveNeeded,
			IsAllAppraisalApproved: isAllApproved,
			NoOfAppraisalApproval: noOfAppraisalApproval,
			AppraisalNotes: appraisalNotes,
			Type: type,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanProposalApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveBusinessProposalFailure(responseData.data));
		} else {
			yield put(approveBusinessProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveBusinessProposalFailure(error));
	}
}

export function* resetApproveBusinessProposalResponse() {
	yield put(approveBusinessProposalResponseChanged());
}

export function* onApproveBusinessProposalDetails() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.APPROVE_BUSINESS_PROPOSAL_START,
		approveBusinessProposalData,
	);
}

export function* onApproveBusinessProposalResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.APPROVE_BUSINESS_PROPOSAL_RESPONSE_RESET_START,
		resetApproveBusinessProposalResponse,
	);
}
/** *********************  END APPROVE BUSINESS LOAN PROPOSAL  ******************** */

/** *********************  START FETCH BUSINESS LOAN PROPOSAL  ******************** */
export function* fetchBusinessLoanProposalData({ payload }: any) {
	try {
		const key = 'FetchBusinessLoanProposalKey';
		const { companyID, loanIndexID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanProposalDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessLoanProposalFailure(responseData.data));
		} else {
			yield put(fetchBusinessLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessLoanProposalFailure(error));
	}
}

export function* resetFetchBusinessLoanProposalResponse() {
	yield put(fetchBusinessLoanProposalResponseChanged());
}

export function* onFetchBusinessLoanProposalDetails() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.FETCH_BUSINESS_LOAN_PROPOSAL_START,
		fetchBusinessLoanProposalData,
	);
}

export function* onFetchBusinessLoanProposalResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.FETCH_BUSINESS_LOAN_PROPOSAL_RESPONSE_RESET,
		resetFetchBusinessLoanProposalResponse,
	);
}

/** *********************  END FETCH BUSINESS LOAN PROPOSAL  ******************** */

/** *********************  START DELETE BUSINESS LOAN PROPOSAL   ******************** */
export function* deleteLoanProposalBusiness({ payload }: any) {
	try {
		const key = 'DeleteBusinessLoanProposalKey';
		const { companyID, loanIndexID, databaseName, userID, userAccessBranchID, userName } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			UserID: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanProposalDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessLoanProposalFailure(responseData.data));
		} else {
			yield put(deleteBusinessLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessLoanProposalFailure(error));
	}
}

export function* resetDeleteBusinessLoanProposalResponse() {
	yield put(deleteBusinessLoanProposalResponseChanged());
}

export function* onDeleteBusinessLoanProposalDetail() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.DELETE_BUSINESS_LOAN_PROPOSAL_START,
		deleteLoanProposalBusiness,
	);
}

export function* onDeleteBusinessLoanProposalResponseReset() {
	yield takeLatest(
		BusinessLoanProposalActionTypes.DELETE_BUSINESS_LOAN_PROPOSAL_RESPONSE_RESET,
		resetDeleteBusinessLoanProposalResponse,
	);
}
/** *********************  END DELETE BUSINESS LOAN PROPOSAL  ******************** */

export function* businessLoanProposalSaga() {
	yield all([
		call(onCreateBusinessLoanProposal),
		call(onCreateBusinessLoanProposalResponseReset),
		call(onUpdateBusinessLoanProposal),
		call(onUpdateBusinessLoanProposalResponseReset),
		call(onGetBusinessLoanProposal),
		call(onGetBusinessLoanProposalListResponseReset),
		call(onApproveBusinessProposalDetails),
		call(onApproveBusinessProposalResponseReset),
		call(onFetchBusinessLoanProposalDetails),
		call(onFetchBusinessLoanProposalResponseReset),
		call(onDeleteBusinessLoanProposalDetail),
		call(onDeleteBusinessLoanProposalResponseReset),
		call(onGetBusinessLoanProposalListResponseReset),
	]);
}
